export default __webpack_public_path__ + "static/media/reddit-logo-transparent-white.7adbd0c4.png";